import * as CONSTANTS from "../../utilities/Constants";
import { IKeyedInProperty } from "./TestplanKeyedIn";
import { ITestPlanInstrument } from "./TestplanInstrument";
import moment from "moment";
import DateFormatting from "../../utilities/DateFormat";
import { ICalculatedPropertyData } from "../shared/ICalculatedPropertyData";

  export interface ITestplanViewData {
    id: string;
    name: string;
    description: string;
    isPDC: boolean;
    codeId: string;
    isEnabled: boolean;
    state: string;
    instruments: ITestPlanInstrument[];
    keyedIns: IKeyedInProperty[];
    grade?: string;
    instrumentDetails?: any[];
    instrumentDetailsName?: string;
    createdOn?: string;
    formatedDate?: string;
    sourceId?: any;
    calculatedProperties?: ICalculatedPropertyData[];
    isGradeCreatedWithTP?: number;
  }
  
  export default class TestplanViewData implements ITestplanViewData {
    id: string;
    name: string;
    description: string;
    isPDC: boolean;
    codeId: string;
    isEnabled: boolean;
    state: string;
    instruments: ITestPlanInstrument[];
    keyedIns: IKeyedInProperty[];
    grade?: string;
    instrumentDetails?: any[] = [];
    instrumentDetailsName?: string;
    createdOn?: string;
    formatedDate?: string;
    sourceId?: any;
    calculatedProperties?: ICalculatedPropertyData[];
    isGradeCreatedWithTP?: number;

    constructor(id: string, name: string, description: string, codeId: string, isEnabled: boolean, instruments: ITestPlanInstrument[], keyedIns: IKeyedInProperty[], isPDC: boolean, grade?: string, instrumentDetails?: any[], createdOn?: string, sourceId?: any, calculatedProperties?: ICalculatedPropertyData[], isGradeCreatedWithTP?: number) {
      this.id = id;
      this.name = name;
      this.description = description;
      this.isPDC = isPDC;
      this.codeId = codeId;
      this.isEnabled = isEnabled;
      this.state = isEnabled ? CONSTANTS.ENABLED : CONSTANTS.DISABLED;
      this.instruments = instruments;
      this.keyedIns = keyedIns;
      this.grade = grade;
      this.instrumentDetails = instrumentDetails;
      const d: string[] = [];
      this.instrumentDetails?.forEach((t: any) => {
          d.push(t.name)    
      });
      this.instrumentDetailsName = d.toString();
      this.createdOn = createdOn
      ? moment.utc(createdOn)
      .utcOffset(DateFormatting.getDateTimeRegionOffset())
      .format(DateFormatting.getDateTimeRegion())
      : createdOn;
    this.formatedDate = createdOn
      ? moment.utc(createdOn)
          .utcOffset(DateFormatting.getDateTimeRegionOffset())
          .format(DateFormatting.getDateTimeRegion())
      : createdOn;
      this.sourceId = sourceId;
      this.calculatedProperties = calculatedProperties;
      this.isGradeCreatedWithTP = isGradeCreatedWithTP;
    }
  }
  
  const defaultTestplanData = new TestplanViewData("", "", "", "", true, [], [], false,"", [], "", "",[], 0);
  export {defaultTestplanData};